import { css } from 'emotion'

export const PlanTasksWatcherStyles = css``
